import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import MiniDrawer from "../Components/MiniDrawer";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Typography from "@mui/material/Typography";
import configData from "../config.json";
import Box from "@mui/material/Box";
import { InputAdornment, TextField } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import Patientlist from "../Components/Patientlist";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Consultationrightbox from "../Components/Consultationrightbox";
import Reports from "../Components/Reports";
import Profilebox from "../Components/Profilebox";
import Casepaper from "../Components/Casepaper";
import RecentHistoryRightBox from "../Components/RecentHistoryRightBox";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Carousel from "react-elastic-carousel";
import moment from "moment";
import AddIcon from "@mui/icons-material/Add";
import { ResponsiveContainer } from "recharts";
import Dropdown from "../Components/Dropdown";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Badge from "@mui/material/Badge";
import IncludedTest from "../../patient/Components/IncludedTest";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import Time from "../Components/Time";
import Displaycasepaper from "../Components/Displaycasepaper";
import AlertShow from "../Components/AlertShow";
import BatchSchedule from "../Components/BatchSchedule";
import PregnancySummary from "../Components/PregnancySummary";
import { downloadFile } from "../../common/utils/fileUtils";
import Showprecription from "../../common/Showprecription";
import PrescriptionData from "../../common/Prescriptiondata";
import { MdZoomInMap } from "react-icons/md";

let p;
let singledate;
let stid;
// let mydate;
// let scheduleinfo;
// let profiledata;
// let patientreport;
function Patient() {
  const doctorTypesYoga = [
    "Batch-1",
    "Batch-2",
    "Batch-3",
    "Batch-4",
    "Morning Session",
    "Evening Session",
  ];

  const consultTypes = ["Online", "In Person"];

  const consultationNumbers = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
  ];
  const [schedule, setSchedule] = useState(false);
  const [myschedule, setMyschedule] = useState(false);
  const [update, setUpdate] = useState(false);
  const [close, setClose] = useState(false);
  const [dateClicked, setDateClicked] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [drType, setDrtype] = useState("");
  const [number, setNumber] = useState("");
  const [report, setReport] = useState(null);
  const [mycasepaper, setCasepaper] = useState(null);
  const [myhealthtracker, setHealthtracker] = useState(null);
  const [pregnancySummaryPatientId, setPregnancySummaryPatientId] =
    useState(null);
  const [profile, setProfile] = useState(null);
  const [cam, setCam] = useState(false);
  const [range, setRange] = useState(false);
  const [consultId, setConsultId] = useState();
  const [timeId, setTimeId] = useState();

  const [patients, setPatients] = useState();
  const [filteredPatients, setFilteredPatients] = useState();

  const [dates, setDates] = useState([]);
  const [weekdate, setWeekdate] = useState([]);
  const [consultations, setConsultations] = useState([]);
  const [pathConsultations, setPathConsultations] = useState([]);
  const [sonoConsultations, setSonoConsultations] = useState([]);

  const [isEmergency, setIsEmergency] = useState(false);
  const [weekSection, setWeekSection] = useState(null); // 'gynec' | 'sono' | 'path' | null

  const [timings, setTimings] = useState();
  const [timingsafter, setTimingsafter] = useState();
  const [timingid, setTimingid] = useState();
  const [scheduledr, setScheduledr] = useState(false);
  const [timeData, setTimeData] = useState();
  const [isUpdatedDate, setIsUpdatedDate] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [changeWeekConsultaionId, setChangeWeekConsultaionId] = useState();
  const [patientId, setPatientId] = useState();
  const [addweekBtn, setAddWeekBtn] = useState(false);
  const [week, setWeek] = useState(null);
  const [timingBatch, setTimingBatch] = useState(null);
  // const [value, setValue] = useState(dates);    initial value use to set already given date selected
  const [value, setValue] = useState(dates);
  const [selectedCalendarDate, setSelectedCalendarDate] = useState(null);
  const [searchMedicine, setSearchMedicine] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [data, setData] = useState([]);
  const [desc, setDesc] = useState(true);
  const [tracker, settracker] = useState(false);
  const [rangeupdate, setUpdaterange] = useState(false);
  const [userData, setUserData] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [dateObjects, setDateObjects] = useState([]);
  const [enabledDates, setEnabledDates] = useState([
    "2023-11-16",
    " 2023-11-25",
  ]);
  const [profileData, setProfileData] = useState([]);
  const [casepaperdata1st, setCasepaperdata1st] = useState("");
  const [casepaperdata2nd, setCasepaperdata2nd] = useState("");
  const [casepaperdata3rd, setCasepaperdata3rd] = useState("");
  const isTabScreen = useMediaQuery({
    query: "(min-width: 768px)" && "(max-width: 1023px)",
  });
  const [submenu, setSubmenu] = useState(false);

  const [isPathology, setIsPathology] = useState(false);
  const [isGynacology, setIsGynacology] = useState(false);
  const [isYogaExperts, setIsYogaExperts] = useState(false);
  const [isSonography, setIsSonography] = useState(false);

  const [notification, setNotification] = useState([]);
  const [shownotification, setShownotification] = useState(false);
  const [count, setCount] = useState(0);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const [consultno, setConsultno] = useState();
  const location = useLocation();
  const rowNumbers = Array.from({ length: 40 }, (_, index) => index + 1);
  const state = location?.state;
  const doctorTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];
  const [consultcomplete, setConsultcomplete] = useState(doctorTypes);
  const [currentPaitientId, setCurrentpatientid] = useState();
  const [allreports, setAllreport] = useState();
  const [currentconsultationNumber, setCurrentconsultationnumber] =
    useState(null);

  const [currentpatent, setCurrentpatient] = useState(null);
  const [showprescriptionmodel, setShowprecriptionmodal] = useState(false);
  const [prescriptiondata, setPrescriptiondata] = useState(null);

  const [showIncludedTest, setShowIncludedTest] = useState(false);
  const [includedTestId, setIncludedTestId] = useState(null);
  const [consultationSummaryMap, setConsultationSummaryMap] = useState({});
  const mapConsultationToTest = (consultationNumber) => {
    switch (Number(consultationNumber)) {
      case 16:
        return 0;
      case 17:
        return 1;
      case 18:
        return 2;
      case 19:
        return 3;
      case 20:
        return 4;
      default:
        return null;
    }
  };

  const handleTestIncluded = (item) => {
    const mappedId = mapConsultationToTest(item.consultation_number);
    setIncludedTestId(mappedId);
    setShowIncludedTest(true);
  };


  const fullscreen = () => {
    setCam(true);
  };

  useEffect(() => {
    getDetail();
    getTimings();
  }, []);

  const viewschedule = (data) => {
    p = data;

    getConsultations(data?.id);
    fetchYogaBatchData(data?.item?.batch_id);
    setSchedule(true);
    setMyschedule(p.id);
    setProfile(false);
    setUpdate(false);
    setCasepaper(false);
    setProfile(false);
    setReport(false);
    setRange(false);
    setPregnancySummaryPatientId(null);
  };

  useEffect(() => {
    const filteredData = patients?.filter(
      (patient) =>
        patient.fname.toLowerCase().includes(searchInput.toLowerCase()) ||
        patient.lname.toLowerCase().includes(searchInput.toLowerCase())
    );
    setFilteredPatients(filteredData);

    const filtered =
      number !== ""
        ? filteredData?.filter((patient) => patient.week === parseInt(number))
        : filteredData;
    setFilteredPatients(filtered);

    const filteredDataconsultcomplete =
      drType !== ""
        ? filtered?.filter(
          (patient) => patient.consultation_completed === parseInt(drType)
        )
        : filtered;
    setFilteredPatients(filteredDataconsultcomplete);
  }, [searchInput, patients, number, drType]);

  const handleChange2 = (event) => {
    const week = event.target.value;
    setNumber(week);
  };

  useEffect(() => {
    switch (userData?.medical_expert_name) {
      case "Gynecologist":
        setIsGynacology(true);
        break;
      case "General Physician":
        break;
      case "Pediatrician":
        break;
      case "Yoga Expert": {
        setIsYogaExperts(true);
        break;
      }
      case "Dietitian":
        break;
      case "Psychiatrist":
        break;
      case "Breastfeeding Consultant":
        break;
      case "Pathology Lab": {
        setIsPathology(true);
        break;
      }
      case "Sonography Centre": {
        setIsSonography(true);
        break;
      }
      default:
    }

    fetchNotifications();
  }, [userData]);

  useEffect(() => {
    if (isPathology === true) {
      setConsultcomplete(doctorTypes.slice(0, 5));
    } else if (isSonography === true) {
      setConsultcomplete(doctorTypes.slice(0, 7));
    } else {
      setConsultcomplete(doctorTypes.slice(0, 16));
    }
  }, [isPathology, isSonography]);
  useEffect(() => {
    if (location?.state?.id === 2) {
      patients?.map((item) => {
        if (item?.id === location?.state?.patientid) {
          p = item;
          setMyschedule(true);
          setSchedule(true);
          getConsultations(p?.id);
          // setConsultno(p?.)
          setUpdate(p?.id);
          setCasepaper(false);
          setProfile(false);
          setReport(false);
          setRange(false);
          setPregnancySummaryPatientId(null);
        }
      });
    }
  }, [location, patients]);

  const updateschedule = (data) => {
    p = data;
    setCurrentpatientid(data?.id);
    setMyschedule(true);
    setSchedule(true);
    getConsultations(p.id);
    setUpdate(p.id);
    setCasepaper(false);
    setProfile(false);
    setReport(false);
    setRange(false);
    setPregnancySummaryPatientId(null);
  };
  const closerightside = () => {
    setClose(true);
    setSchedule(false);
    setPregnancySummaryPatientId(null);
  };
  const showreport = (data) => {
    p = data?.patient_id;
    setCurrentpatient(p);

    api
      .fetchpatientreport({
        patient_id: p,
        doctor_id: null,
      })
      .then((res) => {
        if (res.success) {
          setAllreport(res.reports);
          setSchedule(true);
          setMyschedule(false);
          setUpdate(false);
          setCasepaper(false);
          setProfile(false);
          setReport(p);
          setRange(false);
          setPregnancySummaryPatientId(null);
        }
      })
      .catch((rej) => {
        console.log(rej);
      });
  };
  const showcasepaper = (data) => {
    p = data;
    setSchedule(true);
    setMyschedule(false);
    setUpdate(false);
    setProfile(false);
    setRange(false);
    setReport(false);
    setCasepaper(p.id);
    getcasepaper(p.id);
    setPregnancySummaryPatientId(null);
  };
  const showhealthtracker = (data) => {
    p = data;
    setSchedule(false);
    setMyschedule(false);
    setUpdate(false);
    setProfile(false);
    setReport(false);
    setCasepaper(false);
    setRange(false);
    setHealthtracker(p.id);
    getHealthVitalsForGraph(p.id);
    setPregnancySummaryPatientId(null);
  };
  const showprofile = (data) => {
    p = data;

    setSchedule(true);
    setMyschedule(false);
    setRange(false);
    setReport(false);
    setUpdate(false);
    setProfile(p.id);
    setCasepaper(false);
    setRange(false);
    setPregnancySummaryPatientId(null);
  };
  const showPregnancySummary = (data) => {
    p = data;
    setSchedule(false);
    setMyschedule(false);
    setUpdate(false);
    setProfile(false);
    setReport(false);
    setCasepaper(false);
    setRange(false);
    setHealthtracker(false);
    setPregnancySummaryPatientId(data?.id || null);
  };
  useEffect(() => {
    if (location?.state?.id === 2) {
      consultations?.map((item) => {
        if (item?.id === location?.state?.cardid) {
          let m = item;
          let p = item.weekDates;
          setConsultno(item?.consultation_number);
          setWeekdate(p);
          setDates(p);
          setEnabledDates(p);

          setConsultId(m?.id);
          setRange(true);
          setSchedule(true);
          setMyschedule(false);
          setUpdate(m.id);
          if (m.doctor_scheduled === 1) {
            getDoctorAvailability(m.doctor_id, m.id, m.patient_id);
          }
          setProfile(false);
          setReport(false);
          setCasepaper(false);
          setHealthtracker(false);
          setPregnancySummaryPatientId(null);
          setTimingsafter([]);
          setDateObjects([]);
        }
      });
      // console.log("C ID-changeRange", item);
    }
  }, [location?.state?.cardid, consultations]);

  const changerange = (item) => {
    let p = item.weekDates;
    setCurrentconsultationnumber(item?.consultation_number);
    setWeekdate(p);
    setDates(p);
    setEnabledDates(p);

    setConsultId(item?.id);
    setRange(true);
    setSchedule(true);
    setMyschedule(false);
    setUpdate(item.id);
    if (item.doctor_scheduled === 1) {
      getDoctorAvailability(item.doctor_id, item.id, item.patient_id);
    }
    setProfile(false);
    setReport(false);
    setCasepaper(false);
    setHealthtracker(false);
    setPregnancySummaryPatientId(null);
    setTimingsafter([]);
    setDateObjects([]);
  };

  const changeWeek = (event) => {
    const consultation_id = event.currentTarget.dataset.id;
    const patient_id = event.currentTarget.dataset.patient_id;
    setChangeWeekConsultaionId(consultation_id);
    setPatientId(patient_id);
    setOpen(true);
  };

  const consulationTypeChanege = async (event) => {
    const consulation_id = event.currentTarget.dataset.id;

    const consulationType = event.currentTarget.dataset.type;
    const toConsulationType =
      consulationType === "Online" ? "In-Person" : "Online";

    const userConfirmed = window.confirm(
      `Are you sure you want to change consulation type ${consulationType} to ${toConsulationType}?`
    );

    if (userConfirmed) {
      try {
        const week = event.currentTarget.dataset.week;
        const item = JSON.parse(event.currentTarget.dataset.props);

        const consultation_type = consulationType === "Online" ? "2" : "1";

        const response = await axios.post(
          `${configData.SERVER_API_URL}/consultation/update_consultation`,
          {
            consultation_id: consulation_id,
            consultation_type: consultation_type,
            week: week,
          }
        );

        if (response.data.success) {
          const patientData = {
            id: item.patient_id,
          };
          updateschedule(patientData);
        } else {
        }
      } catch (error) {
        console.log("Error:", error);
      }
    } else {
    }
  };

  const getcasepaper = async (patienid) => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/users/get_case_paper_form`,
        {
          patient_id: patienid,
        }
      );
      if (response.data.success) {
        const responsedata = response.data;
        const d =
          responsedata.case_paper_form.general_lifestyle_habits_history[0];
        const casepaperdata1st = d[0];
        setCasepaperdata1st(casepaperdata1st);

        const e =
          responsedata.case_paper_form.personal_family_medical_profile[0];
        const casepaperdata2nd = e[0];
        setCasepaperdata2nd(casepaperdata2nd);

        const f =
          responsedata.case_paper_form.reproductive_menstrual_history[0];
        const casepaperdata3rd = f[0];
        setCasepaperdata3rd(casepaperdata3rd);
      } else {
      }
    } catch (error) {
      console.log("error in fecthing casepaper detail", error);
    }
  };
  const getDoctorAvailability = async (doctorid, id, patient_id) => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/get_doctor_availability`,
        {
          patient_id: patient_id,
          doctor_id: doctorid,
          consultation_id: id,
        }
      );

      if (response.data?.success) {
        setTimeData(response.data?.doctor_availability[0]);
        const selectedDatesArray = [];
        const oArray = [];
        const selectedDates =
          response.data?.doctor_availability[0]?.dates?.split(",") || [];
        const DoctorAvailabilityData = response.data?.doctor_availability;
        const addedDates = [];
        DoctorAvailabilityData.map((date) => {
          let d = moment(date.dates, "DD-MM-YYYY").format("YYYY-MM-DD");
          if (!addedDates.includes(d)) {
            selectedDatesArray.push(date.dates);
            const formattedDateobj2 = {
              id: date.id,
              date: date.dates,
              timing_id: date.timing_id,
            };
            oArray.push(formattedDateobj2);
            addedDates.push(d);
          }
        });

        const newselectedDatesArray = selectedDatesArray
          .join(",")
          .split(",")
          .map((date) => date.trim());

        setDateObjects(oArray);
        setIsUpdatedDate(true);
        //  setDates(newselectedDatesArray);
        setValue(newselectedDatesArray);
        // setDates(response.data?.doctor_availability[0]?.dates?.split(","));
        setTimingsafter(
          response.data?.doctor_availability[0]?.timings?.split(",")
        );
        setTimingid(
          response.data?.doctor_availability[0]?.timing_id?.split(",")
        );
      }
    } catch (error) {
      console.error("Error get availdates:", error);
    }
  };

  const getNextDates = (e) => {
    // console.log("getNextDates",e.currentTarget.dataset.last_date);
    const lastDate = moment(e.currentTarget.dataset.last_date, "YYYY-MM-DD");
    const item = JSON.parse(e.currentTarget.dataset.item);

    const nextdates = [];
    for (let i = 1; i <= 7; i++) {
      const currentdate = lastDate.clone().add(i, "days");
      nextdates.push(currentdate.format("YYYY-MM-DD"));
    }
    const updateItem = {
      ...item,
      doctor_scheduled: 0,
      weekDates: nextdates,
    };
    changerange(updateItem);
    if (item.doctor_scheduled === 1) {
      getDoctorAvailability(item.doctor_id, item.id, item.patient_id);
    }
    // console.log("--nextdates",nextdates);
  };
  const handlechange = (e) => {
    e.preventDefault();
    setSearchInput(e.target.value);
    setDesc(true);
  };

  const handleAlertMsg = (error_type, msg) => {
    setShowAlert(true);
    setSeverity(error_type);
    setAlertMsg(msg);
    setTimeout(() => {
      setShowAlert(false);
    }, 2500);
  };


  const changeWeekWithSection = (section) => (event) => {
    setWeekSection(section);  // remember where the click came from
    changeWeek(event);        // call your existing handler untouched
  };



  const handleCloseAlert = () => {
    setShowAlert(false);
  };
  const handleChange1 = (event) => {
    setDrtype(event.target.value);
  };

  const onClickDay = (item) => {
    setDateClicked(true);
  };

  const showsubmenu = () => {
    setSubmenu(!submenu);
  };
  useEffect(() => {
    getapi1();
  }, []);
  useEffect(() => { }, [consultations]);

  const fetchNotifications = async () => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/common/get_notification`,
        {
          receiver_id: userData.id,
        }
      );

      if (response.status === 200) {
        const l = response.data.notifications?.length;

        setNotification(response.data.notifications);
        let cnt = response.data.notifications[l - 1].notification_count;
        // console.log("cnt>", cnt);
        setCount(cnt);
      } else {
        console.log("Error in getting notification");
      }
    } catch (error) {
      console.log("Error in getting catch block", error.message);
    }
  };
  const readnotification = async () => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/common/read_notification`,
        { receiver_id: userData.id }
      );
      if (response.status === 200) {
        console.log("successfully read ");
      } else {
        console.log("Error in reading notification");
      }
    } catch (error) {
      console.log("Error", error.message);
    }
    fetchNotifications();
  };

  const shownotificationofdr = () => {
    setShownotification(!shownotification);
    readnotification();
  };

  const getapi1 = async () => {
    try {
      const id = localStorage.getItem("userId");
      if (id) {
        const response = await axios.post(
          `${configData.SERVER_API_URL}/users/get_single_user`,
          {
            userId: id,
          }
        );
        if (response.data.success) {
          setProfileData(response.data);
        } else {
          console.error(
            "Error adding add user education details:",
            response.data.error
          );
        }
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const handleSort = () => {
    const data = filteredPatients;
    data?.sort((a, b) => {
      let c = new Date(a.created_date);
      let d = new Date(b.created_date);
      return desc ? d - c : c - d;
    });
    setFilteredPatients(data);
  };
  const handleSortConsultation = () => {
    const data = filteredPatients;
    data?.sort((a, b) => {
      let c = new Date(a.created_date);
      let d = new Date(b.created_date);
      return desc ? d - c : c - d;
    });
    setFilteredPatients(data);
  };

  // const tileClassName = ({ date }) => {
  //   const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
  //     .toString()
  //     .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
  //   return dates.includes(formattedDate) ? "highlighted" : "";
  // };

  const getHealthVitalsForGraph = async (id) => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/patient/get_health_details_monthwise`,
        { patient_id: id }
      );
      if (response.data) {
        setGraphData(response.data?.health_Details);
      }
    } catch (error) {
      console.error("Error Graphhealthvitals:", error);
    }
  };
  const closefullcam = () => {
    setCam(false);
  };
  const backfromtracker = () => {
    setHealthtracker(false);
  };
  const backfromPregnancySummary = () => {
    setPregnancySummaryPatientId(null);
  };
  const hline = {
    width: "100%",
    height: "1px",
    backgroundColor: "#C0CCDA",
  };
  const updaterange = () => {
    setUpdaterange(true);
  };

  const getTimeing = (id) => {
    // console.log("check---",id)
    if (id) {
      const numId = parseInt(id, 10);
      const matchTime = timings.filter((timing) => timing.id === numId);
      return matchTime[0].start_time;
    }
  };

  const handleClickAddWeek = async () => {
    try {
      // Send emergency flag only when expert is gynac and section is sono/path
      const shouldSendEmergency =
        isGynacology && (weekSection === 'sono' || weekSection === 'path' || weekSection === 'gynec');

      const payload = {
        week_number: week,
        consultation_id: changeWeekConsultaionId,
        ...(shouldSendEmergency ? { Emergency_status: isEmergency ? 1 : 0 } : {}),
      };

      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/update_consultation_week`,
        payload
      );

      if (response.data.success) {
        const msg = response.data.msg;
        handleAlertMsg("success", msg);

        setAddWeekBtn(false);
        setOpen(false);
        setWeek(null);
        setIsEmergency(false);  // reset
        setWeekSection(null);   // reset
        getConsultations(patientId);
      }
    } catch (error) {
      console.log("Error", error);
    }
  };

  const handleClickWeek = async (week) => {
    setWeek(week);
    setAddWeekBtn(true);
  };

  const dateWiseTime = useCallback(
    (singledate) => {
      const date = singledate;
      const dObjects = dateObjects;
      const gettimeDateWise = dObjects.filter((data) => data.date === date);
      const timeArray = [];
      if (
        gettimeDateWise &&
        gettimeDateWise?.length !== 0 &&
        gettimeDateWise[0].timing_id
      ) {
        const ids = gettimeDateWise[0].timing_id;
        const idsArray = ids.split(",");
        setTimingid(idsArray);
        idsArray.forEach((targetId) => {
          const time = getTimeing(targetId);
          timeArray.push(time);
        });
        stid = timeArray;
        setTimingsafter(timeArray);
      } else {
        stid = [];
        setTimingid([]);
        setTimingsafter([]);
      }
    },
    [dateObjects, getTimeing, singledate, timingid, timingsafter]
  );

  const onChange = (newValue) => {
    singledate = moment(newValue).format("YYYY-MM-DD");
    setValue(singledate);
    setSelectedCalendarDate(singledate);
    dateWiseTime(singledate);
    updaterange();
  };

  const tileClassName = ({ date, view }) => {
    if (view !== "month" || !selectedCalendarDate) return null;
    const currentTileDate = moment(date).format("YYYY-MM-DD");
    return currentTileDate === selectedCalendarDate
      ? "calendar-selected-ring"
      : null;
  };

  const getDetail = async () => {
    try {
      const id = localStorage.getItem("userId");
      if (id) {
        const response = await axios.post(
          `${configData.SERVER_API_URL}/users/get_single_user`,
          {
            userId: id,
          }
        );
        if (response.data.success) {
          setUserData(response.data?.user);

          getpatientlist(
            response.data?.user?.area_id,
            response.data.user?.id,
            response.data.user?.medical_expert_id
          );
        } else {
          console.error("Error ----:", response.data.error);
        }
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const getpatientlist = async (areadID, doctorId, medical_expert_id) => {
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/users/get_paitent_list`,
        {
          area_id: areadID,
          doctor_id: doctorId,
          medical_expert_id: medical_expert_id,
        }
      );
      if (response.status === 200) {
        setPatients(response.data.patientList);
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const getConsultations = async (id) => {
    try {
      setConsultationSummaryMap({});
      fetchConsultationSummary(id);

      // Primary (gynac) consultations 
      const mainRes = await axios.post(
        `${configData.SERVER_API_URL}/consultation/get_patient_consultation`,
        {
          patient_id: id,
          doctor_id: profileData.user.id,
        }
      );

      let mainData = mainRes.data?.patient_consultations || [];

      // Prepare placeholders for Pathology & Sonography 
      let pathData = [];
      let sonoData = [];

      // If current user is a Gynecologist, call extra api
      const expertName = profileData?.user?.medical_expert_name?.toLowerCase() || "";
      if (expertName.includes("gynec")) {
        const patientId = id;
        const pathId = profileData?.user?.pathology?.id;
        const sonoId = profileData?.user?.sonography?.id;

        if (pathId) {
          try {
            const pathRes = await axios.post(
              `${configData.SERVER_API_URL}/consultation/get_patient_consultation`,
              {
                patient_id: patientId,
                doctor_id: pathId,
              }
            );
            pathData = pathRes.data?.patient_consultations || [];
          } catch (err) {
            console.warn("Pathology API failed:", err);
          }
        }

        if (sonoId) {
          try {
            const sonoRes = await axios.post(
              `${configData.SERVER_API_URL}/consultation/get_patient_consultation`,
              {
                patient_id: patientId,
                doctor_id: sonoId,
              }
            );
            sonoData = sonoRes.data?.patient_consultations || [];
          } catch (err) {
            console.warn("Sonography API failed:", err);
          }
        }
      }

      // Store data in state 
      setConsultations(mainData);
      setPathConsultations(pathData);
      setSonoConsultations(sonoData);

    } catch (error) {
      console.error("Error fetching consultations:", error);
    }
  };

  const getPreferredSummaryText = (summaryItem) => {
    const consultationSummary = summaryItem?.summary;
    if (consultationSummary && String(consultationSummary).trim() !== "") {
      return String(consultationSummary).trim();
    }

    const prescriptions = Array.isArray(summaryItem?.prescriptions)
      ? summaryItem.prescriptions
      : [];
    const nonNullPrescription = prescriptions.find(
      (item) => item?.prescSummary && String(item.prescSummary).trim() !== ""
    );
    return nonNullPrescription?.prescSummary
      ? String(nonNullPrescription.prescSummary).trim()
      : "";
  };

  const fetchConsultationSummary = async (patientId) => {
    if (!patientId) return;

    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/get_consultation_summary`,
        { patient_id: patientId }
      );

      if (!response?.data?.success) {
        setConsultationSummaryMap({});
        return;
      }

      const summaryList = Array.isArray(response.data.summary)
        ? response.data.summary
        : [];

      const summaryByConsultationId = {};
      summaryList.forEach((summaryItem) => {
        const consultationId = summaryItem?.id;
        if (!consultationId) return;
        const preferredSummary = getPreferredSummaryText(summaryItem);
        if (preferredSummary) {
          summaryByConsultationId[consultationId] = preferredSummary;
          summaryByConsultationId[
            `cn_${summaryItem?.consultation_number}`
          ] = preferredSummary;
        }
      });

      setConsultationSummaryMap(summaryByConsultationId);
    } catch (error) {
      console.error("Error fetching consultation summary:", error);
      setConsultationSummaryMap({});
    }
  };

  const fetchYogaBatchData = async (id) => {
    try {
      const response = await axios.get(
        `${configData.SERVER_API_URL}/consultation/get_yoga_batches_timiing`,
        {}
      );

      if (response.status === 200) {
        let arr = response.data.Batches.filter((item) => item?.id === id);
        if (id === null) {
          setTimingBatch(null);
        } else {
          setTimingBatch(arr[0]);
        }
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  useEffect(() => {
    if (enabledDates?.length > 0) {
      const firstEnabledDate = new Date(enabledDates[0]);

      setValue(firstEnabledDate);
    }
  }, [enabledDates]);

  // const tileDisabled = ({ date }) => {
  //   const formattedDate = date.toISOString().split("T")[0];
  //   return !enabledDates.includes(formattedDate);
  // };

  const isSameDay = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
  const tileDisabled = ({ date, view }) => {
    if (view === "month") {
      const currentDate = date;
      let isEnabled = false;
      setEnabledDates(dates);
      enabledDates?.forEach((enabledDate) => {
        const [year, month, day] = enabledDate?.split("-").map(Number);
        const enabledDateObj = new Date(year, month - 1, day); // month is 0-indexed in JavaScript dates

        if (isSameDay(currentDate, enabledDateObj)) {
          isEnabled = true;
        }
      });

      return !isEnabled;
    }

    return false;
  };
  const getTimings = async () => {
    try {
      const response = await axios.get(
        `${configData.SERVER_API_URL}/consultation/get_doctor_timings`
      );

      if (response.status === 200) {
        setTimings(response.data?.doctor_timing);
      } else {
        console.error("get_doctor_timings Error:", response.statusText);
      }
    } catch (error) {
      console.error("get_doctor_timings Error", error);
    }
  };
  // let dateObjects = [];
  // const getTime = (event) => {
  //   alert("gettime being called");
  //   console.log("Selected time", event);
  //   setTimeId(event);
  //   const formattedDateobj1 = {
  //     date: singledate,
  //     timing_id: event?.join(","),
  //   };
  //   console.log("date and timing together", formattedDateobj1);
  //   setDateObjects((prevObj) => [...prevObj, formattedDateobj1]);

  //   console.log("date and timing together as 1", dateObjects1);
  // };

  const getTime = (event, updateId) => {
    setTimeId(event);
    let formattedDateobj1;
    if (isUpdatedDate && updateId) {
      formattedDateobj1 = {
        id: updateId,
        date: singledate,
        timing_id: event?.join(","),
      };
    } else {
      formattedDateobj1 = {
        date: singledate,
        timing_id: event?.join(","),
      };
    }

    const dateExists = dateObjects?.some((obj) => obj.date === singledate);

    if (dateExists) {
      setDateObjects((prevObj) =>
        prevObj.map((obj) =>
          obj.date === singledate ? formattedDateobj1 : obj
        )
      );
    } else {
      setDateObjects((prevObj) => [...prevObj, formattedDateobj1]);
    }
    const regexddmmyyyy =
      /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;
    if (regexddmmyyyy.test(value) === true) {
      let c_date = moment(value, "DD-MM-YYYY").format(
        "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (Z)"
      );
      setValue(c_date);
    } else {
      setValue(value);
    }
  };

  const newUpdateSchedule = async () => {
    const userId = localStorage.getItem("userId");
    console.log(consultId, currentPaitientId, currentconsultationNumber);
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/update_doctor_availability`,
        {
          consultation_id: consultId,
          dates: dateObjects,
        }
      );
      if (response.status === 200) {
        var msg = "Date & Time Slots Updated!";
        const error_color = "success";
        handleAlertMsg(error_color, msg);
        setSchedule(false);
        setMyschedule(false);
        setProfile(false);
        setUpdate(false);
        setCasepaper(false);
        setProfile(false);
        setReport(false);
        setRange(false);
        setScheduledr(consultId);
        api
          .updatepatientmessagetodoctor({
            patient_id: currentPaitientId,
            doctor_id: userId,
            consultation_number: currentconsultationNumber,
            show_msg: 0,
          })
          .then((res) => {
            if (res.success) {
              getDetail();
            }
          })
          .catch((rej) => {
            console.log(rej);
          });
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.log("Error : ", error);
    }
  };

  const updateScheduleTime = async () => {
    var msg = "add update";
    const error_color = "success";
    handleAlertMsg(error_color, msg);
    // alert("add update");
    try {
      const response = await axios.post(
        `${configData.SERVER_API_URL}/consultation/add_update_doctor_availability`,
        {
          consultation_id: consultId,
          dates: dateObjects,
          // timing_id: timeId?.join(","),
        }
      );

      if (response.status === 200) {
        var msg = "Date & Time Slots Updated!";
        const error_color = "success";
        handleAlertMsg(error_color, msg);
        // alert("Date & Time Slots Updated!");
        setSchedule(false);
        setMyschedule(false);
        setProfile(false);
        setUpdate(false);
        setCasepaper(false);
        setProfile(false);
        setReport(false);
        setRange(false);
        // setScheduledr((prevScheduledr) => {
        //   return consultId;
        // });
        setScheduledr(consultId);
      } else {
        console.error("Error:", response.statusText);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const downloadfiles = (data) => {
    let fileKey = data;
    downloadFile(fileKey);
  };

  const viewprescriptions = (data) => {
    api
      .getprescriptiondata({
        consultation_id: data?.id,
      })
      .then((res) => {
        if (res.success) {
          setShowprecriptionmodal(true);
          setPrescriptiondata({
            data: data,
            medicine: res.Prescrption,
          });
        }
      })
      .catch((rej) => {
        console.log(rej);
      });
  };

  const sectionHdrStyle = {
    width: "86%",
    margin: "16px auto 6px",
    color: "#004AAD",
    fontWeight: 600,
    fontSize: isTabScreen ? "13px" : "28px",
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  };

  const all = Array.isArray(consultations) ? consultations : [];

  const gynecList = all; // all cards in main Gynec section
  const sonoList = all.slice(0, Math.min(8, all.length)); // first 8
  const pathList = all.slice(0, Math.min(5, all.length)); // first 5



  return (
    <>
      {cam === true ? (
        <div className="w-100" style={{ height: "100vh" }}>
          <div
            style={{
              background: "rgba(240, 250, 248, 0.502)",
              border: "1.51832px solid #E8E7E7",
              borderRadius: "60.7327px 60.7327px 0px 0px",
              height: "100%",
              width: "95%",
              paddingTop: "10px",
              margin: "20px auto",
              textAlign: "center",
              color: "#F0588B",
              Weight: "500",
              fontSize: "24px",
              position: "relative",
            }}
          >
            Casepaper: {p?.name}
            <div style={hline}></div>
            <div
              className="ps-2"
              style={{
                background: "white",
                borderRadius: "25px 25px 0px 0px",
                width: "95%",
                height: "90%",
                margin: "20px auto",
                overflowY: "scroll",
                textAlign: "left",
                fontSize: "15px",
              }}
            >
              {casepaperdata1st || casepaperdata2nd || casepaperdata3rd ? (
                <div>
                  <Displaycasepaper
                    casepaperdata1st={casepaperdata1st}
                    casepaperdata2nd={casepaperdata2nd}
                    casepaperdata3rd={casepaperdata3rd}
                  />
                </div>
              ) : (
                <div>Casepaper not filled</div>
              )}
              <button
                className="btn btn-primary btn-sm"
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "26px",
                  // width: "20px",
                  // height: "20px",
                }}
                onClick={() => closefullcam()}
              >
                <MdZoomInMap />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div
          className="d-flex w-100"
        // style={{height:"100vh",overflowY:"hidden"}}
        >
          <div>
            <MiniDrawer />
          </div>
          {pregnancySummaryPatientId ? (
            <PregnancySummary
              patientId={pregnancySummaryPatientId}
              patientName={p?.name || `${p?.fname || ""} ${p?.lname || ""}`.trim()}
              onBack={backfromPregnancySummary}
            />
          ) : myhealthtracker ? (
            <div className="w-100 d-flex justify-content-between">
              {/* <div>{p.id}</div> */}
              <div
                style={{
                  width: "70%",
                  backgroundColor: "#FFF0F5",
                  // width: "100vw",
                }}
              >
                <div
                  className="d-flex align-items-center ps-3"
                  style={{ paddingTop: "59px" }}
                >
                  <div>
                    <img
                      src={"/righticon.png"}
                      onClick={() => backfromtracker()}
                    ></img>
                  </div>
                  <div className="ps-4">
                    <div
                      style={{
                        fontSize: isTabScreen ? "24px" : "32px",
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        color: configData.THEME_COLORS.PRIMARY,
                      }}
                    >
                      {p?.name}
                    </div>
                    <div
                      className="pt-2"
                      style={{
                        color: "#F0588B",
                        fontSize: "24px",
                        fontWeight: "600",
                      }}
                    >
                      Health Vitals
                    </div>
                  </div>
                </div>
                <div style={{ hline }}></div>

                <div style={{ height: "60vh" }}>
                  <Carousel verticalMode itemsToShow={1}>
                    <div
                      className="bg-white"
                      style={{
                        height: "90%",
                        width: "90%",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div className="pt-3 d-flex justify-content-center">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Sugar Level
                        </div>
                        <div
                          style={{
                            padding: 5,
                            marginLeft: "15px",
                            height: "25px",
                            backgroundColor: "#58CF99",
                            display: "flex",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            borderRadius: "4px",
                            alignItems: "center",
                          }}
                        >
                          Normal
                        </div>
                      </div>
                      <ResponsiveContainer
                        width={window.innerWidth / 2.6}
                        height={window.innerHeight / 2}
                      >
                        <LineChart
                          data={graphData && graphData[0]?.sugar_level}
                          margin={{
                            top: 5,
                            // // right: 30,
                            left: isTabScreen ? 0 : 20,
                            bottom: 20,
                            // bottom: 0
                          }}
                        >
                          <XAxis
                            dataKey="month_name"
                            axisLine={true}
                            fontSize={"12px"}
                            domain={["auto", "auto"]}
                          />
                          <YAxis
                            datakey="vl"
                            axisLine={true}
                            fontSize={"12px"}
                          />
                          <Tooltip />
                          <Legend
                            iconType="circle"
                            iconSize={10}
                            height={20}
                            wrapperStyle={{
                              fontSize: isTabScreen ? "10px" : "14px",
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="avg_sugar_level"
                            stroke="#4791FF"
                            strokeWidth={2}
                            dot={{
                              fill: "#4791FF",
                              r: 3,
                            }}
                            activeDot={{ r: 8 }}
                          />
                          <Line
                            type="monotone"
                            dataKey="ideal_sugar"
                            stroke="#02BC77"
                            strokeWidth={2}
                            dot={{
                              fill: "#02BC77",
                              r: 3,
                            }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>

                    <div
                      className="bg-white"
                      style={{
                        height: "90%",
                        width: "90%",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div className="pt-3 d-flex justify-content-center">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Blood Pressure
                        </div>
                        <div
                          style={{
                            padding: 5,
                            marginLeft: "15px",
                            height: "25px",
                            backgroundColor: "#58CF99",
                            display: "flex",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            borderRadius: "4px",
                            alignItems: "center",
                          }}
                        >
                          Normal
                        </div>
                      </div>
                      <ResponsiveContainer
                        width={window.innerWidth / 2.6}
                        height={window.innerHeight / 2}
                      >
                        <LineChart
                          // width={isTabScreen ? 390 : isScreen3 ? 580 : 550}
                          // height={isTabScreen ? 300 : isScreen3 ? 450 : 250}
                          data={graphData && graphData[0]?.blood_pressure}
                          margin={{
                            top: 5,
                            // // right: 30,
                            left: isTabScreen ? 0 : 20,
                            bottom: 20,
                            // bottom: 0
                          }}
                        >
                          <XAxis
                            dataKey="month_name"
                            axisLine={true}
                            fontSize={"12px"}
                            domain={["auto", "auto"]}
                          />
                          <YAxis
                            datakey="vl"
                            axisLine={true}
                            fontSize={"12px"}
                          />
                          <Tooltip />
                          <Legend
                            iconType="circle"
                            iconSize={10}
                            height={20}
                            wrapperStyle={{
                              fontSize: isTabScreen ? "10px" : "14px",
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="avg_diastolic_blood_pressure"
                            stroke="#4791FF"
                            strokeWidth={2}
                            dot={{
                              fill: "#4791FF",
                              r: 3,
                            }}
                            activeDot={{ r: 8 }}
                          />
                          <Line
                            type="monotone"
                            dataKey="avg_systolic_blood_pressure"
                            stroke="purple"
                            strokeWidth={2}
                            dot={{
                              fill: "purple",
                              r: 3,
                            }}
                            activeDot={{ r: 8 }}
                          />
                          <Line
                            type="monotone"
                            dataKey="ideal_diastolic_pressure"
                            stroke="#02BC77"
                            strokeWidth={2}
                            dot={{
                              fill: "#02BC77",
                              r: 3,
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="ideal_systolic_pressure"
                            stroke="#02BC77"
                            strokeWidth={2}
                            dot={{
                              fill: "#02BC77",
                              r: 3,
                            }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                    <div
                      className="bg-white"
                      style={{
                        height: "90%",
                        width: "90%",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div className="pt-3 d-flex justify-content-center">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Temperature Level
                        </div>
                        <div
                          style={{
                            padding: 5,
                            marginLeft: "15px",
                            height: "25px",
                            backgroundColor: "#58CF99",
                            display: "flex",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            borderRadius: "4px",
                            alignItems: "center",
                          }}
                        >
                          Normal
                        </div>
                      </div>
                      <ResponsiveContainer
                        width={window.innerWidth / 2.6}
                        height={window.innerHeight / 2}
                      >
                        <LineChart
                          // width={isTabScreen ? 390 : isScreen3 ? 580 : 550}
                          // height={isTabScreen ? 300 : isScreen3 ? 450 : 250}
                          data={graphData && graphData[0]?.temperature}
                          margin={{
                            top: 5,
                            // // right: 30,
                            left: isTabScreen ? 0 : 20,
                            bottom: 20,
                            // bottom: 0
                          }}
                        >
                          <XAxis
                            dataKey="month_name"
                            axisLine={true}
                            fontSize={"12px"}
                            domain={["auto", "auto"]}
                          />
                          <YAxis
                            datakey="vl"
                            axisLine={true}
                            fontSize={"12px"}
                          />
                          <Tooltip />
                          <Legend
                            iconType="circle"
                            iconSize={10}
                            height={20}
                            wrapperStyle={{
                              fontSize: isTabScreen ? "10px" : "14px",
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="avg_temperature"
                            stroke="#4791FF"
                            strokeWidth={2}
                            dot={{
                              fill: "#4791FF",
                              r: 3,
                            }}
                            activeDot={{ r: 8 }}
                          />
                          <Line
                            type="monotone"
                            dataKey="ideal_max_temperature"
                            stroke="#02BC77"
                            strokeWidth={2}
                            dot={{
                              fill: "#02BC77",
                              r: 3,
                            }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>

                    <div
                      className="bg-white"
                      style={{
                        height: "90%",
                        width: "90%",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div className="pt-3 d-flex justify-content-center">
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                          }}
                        >
                          Weight
                        </div>
                        <div
                          style={{
                            padding: 5,
                            marginLeft: "15px",
                            height: "25px",
                            backgroundColor: "#58CF99",
                            display: "flex",
                            justifyContent: "center",
                            color: "#FFFFFF",
                            borderRadius: "4px",
                            alignItems: "center",
                          }}
                        >
                          Normal
                        </div>
                      </div>
                      <ResponsiveContainer
                        width={window.innerWidth / 2.6}
                        height={window.innerHeight / 2}
                      >
                        <LineChart
                          // width={isTabScreen ? 390 : isScreen3 ? 580 : 550}
                          // height={isTabScreen ? 300 : isScreen3 ? 450 : 250}
                          data={graphData && graphData[0]?.weight}
                          margin={{
                            top: 5,
                            // // right: 30,
                            left: isTabScreen ? 0 : 20,
                            bottom: 20,
                            // bottom: 0
                          }}
                        >
                          <XAxis
                            dataKey="month_name"
                            axisLine={true}
                            fontSize={"12px"}
                            domain={["auto", "auto"]}
                          />
                          <YAxis
                            datakey="vl"
                            axisLine={true}
                            fontSize={"12px"}
                          />
                          <Tooltip />
                          <Legend
                            iconType="circle"
                            iconSize={10}
                            height={20}
                            wrapperStyle={{
                              fontSize: isTabScreen ? "10px" : "14px",
                            }}
                          />
                          <Line
                            type="monotone"
                            dataKey="avg_weight"
                            stroke="#4791FF"
                            strokeWidth={2}
                            dot={{
                              fill: "#4791FF",
                              r: 3,
                            }}
                            activeDot={{ r: 8 }}
                          />
                          <Line
                            type="monotone"
                            dataKey="ideal_weight"
                            stroke="#02BC77"
                            strokeWidth={2}
                            dot={{
                              fill: "#02BC77",
                              r: 3,
                            }}
                          />
                        </LineChart>
                      </ResponsiveContainer>
                    </div>
                  </Carousel>
                </div>
              </div>
              <div style={{ width: "30%" }}>
                <RecentHistoryRightBox data={p} />
              </div>
            </div>
          ) : (
            <div
              style={{
                backgroundColor: "rgb(246, 231, 236)",
                display: schedule === true && "flex",
                width: "100vw",
              }}
            >
              <div
                style={{
                  width: schedule === true ? "70%" : "100%",
                }}
              >
                <div
                  style={{
                    paddingTop: 50,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    backgroundColor: "rgb(246, 231, 236)",
                  }}
                >
                  <div>
                    <div
                      style={{
                        marginLeft: schedule === true ? "10px" : "60px",
                        fontSize: isTabScreen ? "24px" : "32px",
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        color: configData.THEME_COLORS.PRIMARY,
                      }}
                    >
                      {"Patient"}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "60px",
                    }}
                  >
                    <Badge
                      badgeContent={count?.toString()}
                      color="primary"
                      overlap="circular"
                      style={{ left: -5, cursor: "pointer" }}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "#FFFFFF",
                          backgroundColor: "#E42346",
                        },
                      }}
                    >
                      <NotificationsIcon
                        onClick={shownotificationofdr}
                        sx={{
                          width: "25px",
                          height: "25px",
                          color: "#004AAD",
                          cursor: "pointer",
                        }}
                      />
                    </Badge>
                    <Dropdown
                      submenu={submenu}
                      profileData={profileData}
                      onClick={() => showsubmenu()}
                      page="patient"
                    />
                  </div>
                </div>
                <div
                  style={{
                    paddingRight: schedule === true ? "10px" : "40px",
                    paddingLeft: schedule === true ? "10px" : "60px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: "120px",
                      // marginLeft: "2%",
                      // marginRight: "2%",
                      backgroundColor: "white",
                      marginTop: "20px",
                      marginBottom: "10px",
                      borderRadius: "15px",
                      // display: "flex",
                      // justifyContent: "space-between",
                      paddingTop: "22px",
                      paddingBottom: "12px",
                    }}
                  >
                    <div
                      onClick={() => {
                        setDesc(!desc);
                        handleSort();
                      }}
                      className="my-1 me-4"
                      style={{
                        fontSize: isTabScreen ? "12px" : "17.54px",
                        color: configData.THEME_COLORS.PRIMARY,
                        fontWeight: "500",
                        fontFamily: "Poppins",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      {desc ? "New - Old" : "Old - New"}
                      <img
                        src={"/Communication/sort.png"}
                        style={{
                          marginTop: "4px",
                          marginRight: "12px",
                          resizeMode: "contain",
                          height: "20px",
                          width: "20px",
                        }}
                      />{" "}
                    </div>

                    <div
                      className="d-flex justify-space-between align-items-center"
                      style={{ width: "98%", margin: "0px auto" }}
                    >
                      {/* searchbar */}
                      {/* <div style={{ position: "relative", width: "38%" }}> */}
                      <div style={{ width: "40%" }}>
                        <TextField
                          className="w-100"
                          type="search"
                          placeholder="Search Patient"
                          onChange={handlechange}
                          value={searchInput}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <span>
                                  <SearchIcon />
                                </span>
                              </InputAdornment>
                            ),
                            sx: {
                              width: "100%",
                              background: "#F2F2F2",
                              borderRadius: "50px",
                              border: "none",
                              height: isTabScreen ? "40px" : "45px",
                              color: "black",
                              fontSize: isTabScreen ? "10px" : "15px",
                              paddingLeft: "20px", // Adjust as needed for icon or content alignment
                              "& fieldset": { border: "none" },
                            },
                          }}
                        />
                      </div>
                      {/* </div> */}
                      <Box
                        sx={{
                          width: "23%",
                          margin: "8px auto",
                        }}
                      >
                        <FormControl fullWidth size={"small"}>
                          <Select
                            sx={{
                              boxShadow: "none",
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            }}
                            style={{
                              backgroundColor: "#F2F2F2",
                              fontSize: isTabScreen ? "10px" : "15px",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                            }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={drType}
                            displayEmpty
                            onChange={handleChange1}
                          >
                            <MenuItem
                              value=""
                              style={{
                                fontSize: isTabScreen ? "10px" : "15px",
                                fontFamily: "Poppins",
                                fontWeight: "500",
                              }}
                            >
                              Consultation Completed
                            </MenuItem>

                            {isYogaExperts
                              ? doctorTypesYoga.map((item, index) => (
                                <MenuItem
                                  key={index}
                                  value={index}
                                  style={{
                                    fontSize: isTabScreen ? "10px" : "16px",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item}
                                </MenuItem>
                              ))
                              : consultcomplete?.map((item, index) => (
                                <MenuItem
                                  key={index}
                                  value={item}
                                  style={{
                                    fontSize: isTabScreen ? "10px" : "16px",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Box>
                      <Box
                        sx={{
                          width: "23%",
                          margin: "8px auto",
                        }}
                      >
                        <FormControl fullWidth size={"small"}>
                          <Select
                            sx={{
                              boxShadow: "none",
                              ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            }}
                            style={{
                              backgroundColor: "#F2F2F2",
                              fontSize: isTabScreen
                                ? "10px"
                                : isTabScreen && clicked
                                  ? "10px"
                                  : "16px",
                              fontFamily: "Poppins",
                              fontWeight: "500",
                            }}
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={number}
                            onChange={handleChange2}
                            displayEmpty
                          >
                            <MenuItem
                              value=""
                              style={{
                                fontSize: isTabScreen ? "12px" : "16px",
                                fontFamily: "Poppins",
                                fontWeight: "500",
                              }}
                            >
                              Pregnancy Week
                            </MenuItem>
                            {consultationNumbers.map((item, index) => {
                              return (
                                <MenuItem
                                  value={item}
                                  style={{
                                    fontSize: isTabScreen ? "10px" : "16px",
                                    fontFamily: "Poppins",
                                    fontWeight: "500",
                                  }}
                                >
                                  {item}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>
                      <div
                        style={{
                          fontSize: isTabScreen ? "10px" : "15.54px",
                          fontWeight: "500",
                          color: configData.THEME_COLORS.PRIMARY,
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          width: "10%",
                          textAlign: "center",
                        }}
                        onClick={() => {
                          setSearchInput("");
                        }}
                      >
                        CLEAR ALL
                      </div>
                    </div>
                  </div>

                  <div
                    className="container"
                    style={{
                      overflowY: "auto",
                      height: "85vh",
                      overflowX: "hidden",
                    }}
                  >
                    <div
                      className="row"
                      style={{
                        marginRight: schedule === true ? "4px" : "10px",
                      }}
                    >
                      {filteredPatients?.map((item) => {
                        return (
                          <Patientlist
                            id={item.id}
                            name={item.fname + " " + item.lname}
                            age={item.age}
                            pregnancy_days={item.pregnancy_days}
                            viewschedule={item.viewschedule}
                            updateschedule={item.updateschedule}
                            viewprofile={item.viewprofile}
                            healthtracker={item.healthtracker}
                            reports={item.reports}
                            casepaper={item.casepaper}
                            onClick={viewschedule}
                            onClick1={updateschedule}
                            onClick2={showreport}
                            onClick3={showcasepaper}
                            onClick4={showhealthtracker}
                            onClick5={showprofile}
                            onClick6={showPregnancySummary}
                            img1={item?.profile_pic}
                            img2={"/Communication/progresscurve.png"}
                            schedule={schedule}
                            myschedule={myschedule}
                            profile={profile}
                            update={update}
                            report={report}
                            mycasepaper={mycasepaper}
                            myhealthtracker={myhealthtracker}
                            pregnancySummaryPatientId={
                              pregnancySummaryPatientId
                            }
                            item={item}
                            isPathology={isPathology}
                            isYogaExperts={isYogaExperts}
                            isGynacology={isGynacology}
                            isSonography={isSonography}
                            state={state}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {schedule === true && (
                <div
                  style={{
                    width: "30%",
                    backgroundColor: "white",
                    paddingTop: "50px",
                  }}
                >
                  <div className="px-2 d-flex align-items-center">
                    <img
                      src="/lefticon.png"
                      style={{
                        height: "30px",
                        width: "23px",
                        paddingLeft: "5px",
                        color: configData.THEME_COLORS.SECONDARY,
                      }}
                      alt="nt found"
                      onClick={() => closerightside()}
                    ></img>
                    <div
                      style={{
                        fontSize: isTabScreen ? "24px" : "32px",
                        fontWeight: "600",
                        fontFamily: "Poppins",
                        color: configData.THEME_COLORS.SECONDARY,
                        paddingLeft: isTabScreen ? "10px" : "15px",
                      }}
                    >
                      {location?.state?.id == 2
                        ? p?.fname + " " + p?.lname
                        : p?.name}
                    </div>
                  </div>
                  <br></br>
                  <div style={hline}></div>
                  {myschedule ? (
                    showIncludedTest ? (
                      <IncludedTest
                        includedtest={includedTestId}
                        onClick={() => setShowIncludedTest(false)}
                      />
                    ) : (
                      <>
                        {" "}
                        <Typography
                          paragraph
                          sx={{
                            color: configData.THEME_COLORS.PRIMARY,
                            display: "flex",
                            justifyContent: "end",
                            padding: "10px 10px",
                          }}
                        >
                          <div
                            style={{
                              fontSize:
                                isTabScreen && clicked
                                  ? "8px"
                                  : isTabScreen
                                    ? "12px"
                                    : "20px",
                              fontWeight: "500",
                              fontFamily: "Poppins",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setDesc(!desc);
                              handleSortConsultation();
                            }}
                          >
                            {desc ? "New - Old" : "Old - New"}
                          </div>

                          <img
                            src={"/Communication/sort.png"}
                            style={{
                              resizeMode: "contain",
                              height: "18px",
                              width: "18px",
                            }}
                            alt="nt found"
                          />
                        </Typography>
                        {update ? (
                          <div
                            style={{
                              fontSize: isTabScreen ? "20px" : "28px",
                              fontWeight: "600",
                              fontFamily: "Poppins",
                              paddingLeft: "20px",
                              color: configData.THEME_COLORS.PRIMARY,
                            }}
                          >
                            Select Consultation
                          </div>
                        ) : (
                          <div
                            style={{
                              fontSize: isTabScreen ? "20px" : "28px",
                              fontWeight: "600",
                              fontFamily: "Poppins",
                              paddingLeft: "20px",
                              color: configData.THEME_COLORS.PRIMARY,
                            }}
                          >
                            View Schedule
                          </div>
                        )}
                        <div
                          style={{
                            height: "100vh",
                            overflowY: "scroll",
                          }}
                        >
                          {/* {timingBatch === null ? ( */}
                          {!isGynacology ? (
                            consultations.map((item, index) => {
                              const isCancelled = String(item?.consultation_status || "").toLowerCase() === "cancelled";
                              return (
                                <Consultationrightbox
                                  key={item?.id ?? index}
                                  item={item}
                                  index={index}
                                  isPathology={isPathology}
                                  dates={dates}
                                  update={update}
                                  scheduledr={scheduledr}
                                  onClick={isCancelled ? undefined : () => changerange(item)}
                                  changerange={isCancelled ? undefined : changerange}
                                  changeWeek={isCancelled ? undefined : changeWeek}
                                  getNextDates={isCancelled ? undefined : getNextDates}
                                  consulationTypeChanege={isCancelled ? undefined : consulationTypeChanege}
                                  consultationSummary={
                                    consultationSummaryMap[item?.id] ||
                                    consultationSummaryMap[
                                    `cn_${item?.consultation_number}`
                                    ] ||
                                    ""
                                  }
                                  testincludedbtn={
                                    mapConsultationToTest(
                                      item?.consultation_number
                                    ) !== null
                                      ? "Tests Included"
                                      : undefined
                                  }
                                  onTestIncludedClick={
                                    mapConsultationToTest(
                                      item?.consultation_number
                                    ) !== null
                                      ? () => handleTestIncluded(item)
                                      : undefined
                                  }
                                />
                              );
                            })
                          ) : (
                            <>
                              {/*GYNEC */}
                              {consultations.length > 0 && <div style={sectionHdrStyle}>Gynaecology</div>}
                              {consultations.map((item, index) => (
                                <Consultationrightbox
                                  key={`g-${item?.id ?? index}`}
                                  variant="gynec"
                                  item={item}
                                  index={index}
                                  dates={dates}
                                  update={update}
                                  scheduledr={scheduledr}
                                  onClick={() => changerange(item)}
                                  changerange={changerange}
                                  changeWeek={changeWeekWithSection('gynec')}
                                  getNextDates={getNextDates}
                                  consulationTypeChanege={consulationTypeChanege}
                                  consultationSummary={
                                    consultationSummaryMap[item?.id] ||
                                    consultationSummaryMap[
                                    `cn_${item?.consultation_number}`
                                    ] ||
                                    ""
                                  }
                                />
                              ))}

                              {/*SONOG */}
                              {sonoConsultations.length > 0 && <div style={sectionHdrStyle}>Sonography</div>}
                              {sonoConsultations.map((item, index) => (
                                <Consultationrightbox
                                  key={`s-${item?.id ?? index}`}
                                  variant="sono"
                                  item={item}
                                  index={index}
                                  dates={dates}
                                  update={update}
                                  scheduledr={scheduledr}
                                  onClick={() => changerange(item)}
                                  changerange={changerange}
                                  changeWeek={changeWeekWithSection('sono')}
                                  getNextDates={getNextDates}
                                  consulationTypeChanege={consulationTypeChanege}
                                  consultationSummary={
                                    consultationSummaryMap[item?.id] ||
                                    consultationSummaryMap[
                                    `cn_${item?.consultation_number}`
                                    ] ||
                                    ""
                                  }
                                />
                              ))}

                              {/*PATH */}
                              {pathConsultations.length > 0 && <div style={sectionHdrStyle}>Pathology</div>}
                              {pathConsultations.map((item, index) => (
                                <Consultationrightbox
                                  key={`p-${item?.id ?? index}`}
                                  variant="path"
                                  item={item}
                                  index={index}
                                  isPathology={isPathology}
                                  dates={dates}
                                  update={update}
                                  scheduledr={scheduledr}
                                  onClick={() => changerange(item)}
                                  changerange={changerange}
                                  changeWeek={changeWeekWithSection('path')}
                                  getNextDates={getNextDates}
                                  consulationTypeChanege={consulationTypeChanege}
                                  consultationSummary={
                                    consultationSummaryMap[item?.id] ||
                                    consultationSummaryMap[
                                    `cn_${item?.consultation_number}`
                                    ] ||
                                    ""
                                  }
                                  testincludedbtn="Tests Included"
                                  onTestIncludedClick={() => handleTestIncluded(item)}
                                />
                              ))}
                            </>
                          )}


                          {/* ) : ( */}
                          {isYogaExperts && <BatchSchedule data={timingBatch} />}
                          {/* )} */}
                        </div>
                      </>
                    )
                  ) : range === true ? (
                    <div>
                      <style>
                        {`
                          .react-calendar__tile.calendar-selected-ring {
                            border-radius: 999px !important;
                            box-shadow: inset 0 0 0 2px #f0588b !important;
                          }
                          .react-calendar__tile.calendar-selected-ring:enabled:hover,
                          .react-calendar__tile.calendar-selected-ring:enabled:focus {
                            box-shadow: inset 0 0 0 2px #f0588b !important;
                          }
                        `}
                      </style>
                      <div
                        className="my-3 text-center"
                        style={{
                          fontStyle: "normal",
                          fontWeight: "600",
                          fontSize: isTabScreen ? "18px" : "24px",
                          color: "rgba(0, 74, 173, 0.8)",
                        }}
                      >
                        Update Schedule
                      </div>
                      <div className="my-2 text-center">
                        Consultation {consultno}
                      </div>
                      <div style={{ marginTop: 20, alignSelf: "center" }}>
                        <Calendar
                          // mydate={mydate}
                          onChange={onChange}
                          tileDisabled={tileDisabled} // dates={dates}
                          tileClassName={tileClassName}
                          // selectRange={true}
                          timeData={timeData}
                          value={value}
                          showRangeLabels={true}
                          onClickDay={() => {
                            onClickDay();
                          }}
                        />
                      </div>

                      <div className="mt-2 text-center">
                        {rangeupdate === true ? (
                          <>
                            <div className="d-flex align-items-center justify-content-center">
                              <div
                                style={{
                                  backgroundColor: "#58CF99",
                                  height: "13px",
                                  width: "13px",
                                  borderRadius: "50%",
                                }}
                              ></div>
                              <div
                                style={{
                                  fontSize: isTabScreen ? "6px" : "12px",
                                  paddingLeft: "5px",
                                  textAlign: "center",
                                }}
                              >
                                Current Selected Range
                              </div>
                            </div>
                            {/* <div className="my-4" style={{ color: "#26931F" }}>
                              Date Range Updated Successfully!
                            </div> */}

                            <Time
                              showTime={range}
                              value={value}
                              timings={timings}
                              dateObjects={dateObjects}
                              timingsafter={timingsafter}
                              timingid={timingid}
                              getTime={getTime}
                              updateSchedule={updateScheduleTime}
                              newUpdateSchedule={newUpdateSchedule}
                              dates={dates}
                              isUpdatedDate={isUpdatedDate}
                              // title={trimesternm}
                              // drpost={drpost}
                              // drstatus={drstatus}
                              // onClick={onClick}
                              date={singledate}
                            />
                          </>
                        ) : (
                          <>
                            <div className="px-3 mt-3 d-flex align-items-center justify-content-between w-100">
                              <div
                                className="d-flex align-items-center"
                                style={{ marginLeft: "8%" }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "rgba(169, 202, 187, 0.5)",
                                    height: "2vh",
                                    width: "1vw",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  style={{
                                    fontSize: isTabScreen ? "6px" : "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  Previous Range
                                </div>
                              </div>
                              <div
                                className="d-flex align-items-center"
                                style={{ marginRight: "8%" }}
                              >
                                <div
                                  style={{
                                    backgroundColor: "#58CF99",
                                    height: "2vh",
                                    width: "1vw",
                                    borderRadius: "50%",
                                  }}
                                ></div>
                                <div
                                  style={{
                                    fontSize: isTabScreen ? "6px" : "12px",
                                    paddingLeft: "12px",
                                  }}
                                >
                                  Current Selected Range
                                </div>
                              </div>
                            </div>
                            {/* <button
                              style={{
                                background: "#004AAD",
                                height: "40px",
                                width: "110px",
                                border: "1px solid rgba(0, 74, 173, 0.5)",
                                background: "#004AAD",
                                margin: "10px auto",
                                color: "white",
                                borderRadius: "6px",
                              }}
                              className="my-3"
                              onClick={() => updaterange()}
                            >
                              Update
                            </button> */}
                          </>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                  {/* {range === true && <div>jndjnjdnqndeqdoo</div>} */}

                  {report && (
                    <Reports
                      report={p}
                      allreports={allreports}
                      showreport={showreport}
                      currentPaitientId={currentpatent}
                      downloadfiles={downloadfiles}
                      viewprescriptions={viewprescriptions}
                      patient_id={report}
                    />
                  )}
                  {profile && <Profilebox userData={p} profile={profile} />}
                  {mycasepaper && (
                    <Casepaper
                      onClick={() => fullscreen()}
                      cam={cam}
                      mycasepaper={mycasepaper}
                      casepaperdata1st={casepaperdata1st}
                      casepaperdata2nd={casepaperdata2nd}
                      casepaperdata3rd={casepaperdata3rd}
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <AlertShow
        alertShowHide={showAlert}
        alertClose={handleCloseAlert}
        setalertMsg={alertMsg}
        severity={severity}
      />

      <Modal
        show={open}
        onHide={handleClose}
        // backdrop="static"
        keyboard={false}
        className="p-5"
      >
        <Modal.Header className="d-flex justify-content-start ">
          <img src="/lefticon.png"></img>
          <h2 className="mx-4 s-w-title">Select Week</h2>
        </Modal.Header>
        <Modal.Body>
          <Table borderless responsive className="c-w-table">
            <tbody className="text-center">
              {rowNumbers.map((data, i) =>
                i % 7 === 0 ? (
                  <tr key={i}>
                    {[0, 1, 2, 3, 4, 5, 6].map((col) => (
                      <td
                        key={col}
                        onClick={() => handleClickWeek(rowNumbers[i + col])}
                        style={{ cursor: "pointer" }}
                        className={
                          week === rowNumbers[i + col] && week !== null
                            ? "s-w-active-td"
                            : null
                        }
                      >
                        {rowNumbers[i + col]}
                      </td>
                    ))}
                  </tr>
                ) : null
              )}
            </tbody>
          </Table>
        </Modal.Body>

        {addweekBtn && isGynacology && (weekSection === 'sono' || weekSection === 'path' || weekSection === 'gynec') && (
          <div className="px-4 pb-2">
            <label style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
              <input
                type="checkbox"
                checked={isEmergency}
                onChange={(e) => setIsEmergency(e.target.checked)}
                style={{ marginTop: 4 }}
              />
              <span style={{ lineHeight: 1.3 }}>
                <strong>Mark this as Emergency Prepone Case</strong> — requires
                immediate attention and action within the next 24 hours. Notify all to act
                within 24 hours.
              </span>
            </label>
          </div>
        )}

        {addweekBtn && (
          <Modal.Footer>
            <button className="mx-auto my-button" onClick={handleClickAddWeek}>
              ADD
            </button>
          </Modal.Footer>
        )}


      </Modal>

      <Showprecription />

      {showprescriptionmodel && (
        <PrescriptionData
          open={showprescriptionmodel}
          data={prescriptiondata}
          onClose={() => {
            setShowprecriptionmodal(false);
            setPrescriptiondata([]);
          }}
        />
      )}
    </>
  );
}

export default Patient;
